// OneDrive:IgnoreCodeCoverage

export * from '@ms/telemetry-manager/lib/events/Engagement.event';
export { Engagement as default } from '@ms/telemetry-manager/lib/events/Engagement.event';
